import { render } from "./addPaymentViaCompany.vue?vue&type=template&id=4d925489"
import script from "./addPaymentViaCompany.vue?vue&type=script&lang=js"
export * from "./addPaymentViaCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__